import React, { useState, useEffect } from 'react';

import { Table, Tag, Card, message } from 'antd';
import ListPageHeader from '@shared/ListPageHeader';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { billingService } from '@services/admin/billingService';

const STATUS_COLORS = {
  open: 'blue',
  closed: 'orange',
  invoiced: 'green',
};

export default function AdminBillingsList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [billings, setBillings] = useState([]);

  const fetchBillings = async () => {
    setLoading(true);
    try {
      const res = await billingService.fetchList();
      if (res.success) {
        setBillings(res.data || []);
      } else {
        message.error(t('common.error.load_failed'));
      }
    } catch (error) {
      message.error(t('common.error.network_error'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBillings();
  }, []);

  const columns = [
    {
      title: t('admin.billings.fields.name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('admin.billings.fields.period'),
      key: 'period',
      render: (_, record) => `${record.period_start} ~ ${record.period_end}`,
    },
    {
      title: t('admin.billings.fields.status'),
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={STATUS_COLORS[status]}>
          {t(`admin.billings.statuses.${status}`)}
        </Tag>
      ),
    },
    {
      title: t('admin.billings.fields.total_amount'),
      dataIndex: 'total_amount',
      key: 'total_amount',
      align: 'right',
      render: (val) => Number(val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: t('admin.billings.fields.items_count'),
      dataIndex: 'items_count',
      key: 'items_count',
      align: 'center',
    },
  ];

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['billings']}
      />
      <Card>
        <Table
          columns={columns}
          dataSource={billings}
          rowKey="id"
          loading={loading}
          pagination={false}
          onRow={(record) => ({
            onClick: () => navigate(`/billings/${record.id}`),
            style: { cursor: 'pointer' },
          })}
        />
      </Card>
    </div>
  );
}
